import { InternalButton } from "@sharedComponents/buttons";

import { usePreviewModeContext } from "@contexts/preview-mode-context";

import { BOOK_A_CALL } from "@constants/routes";

import styles from "./main.module.scss";

const ExitDemoModeCta = () => {
  const { resetPreviewMode } = usePreviewModeContext();

  const onDemoFinish = () => resetPreviewMode(BOOK_A_CALL);

  return (
    <InternalButton
      styleType="primary"
      onClick={onDemoFinish}
      className={`${styles.fullBlockBtn} exit-demo-btn`}
    >
      Exit Demo
    </InternalButton>
  );
};

export default ExitDemoModeCta;
